<template>
  <label
    class="rr-checkbox"
    :class="classes"
  >
    <span class="rr-checkbox__content">
      <input
        class="rr-checkbox__input"
        v-model="internalValue"
        :name="name"
        :indeterminate.prop="indeterminate"
        :disabled="disabled"
        :value="value"
        type="checkbox"
      >
      <span class="rr-checkbox__marker">
        <Icon name="check-bold"></Icon>
      </span>
      <span
        class="rr-checkbox__text"
        v-if="$slots.default"
      >
        <slot></slot>
      </span>
    </span>
  </label>
</template>

<script>
import Icon from '@rr-component-library/icon/src/main';

export default {
  name: 'Checkbox',
  model: {
    prop: 'inputModel',
  },
  components: {
    Icon,
  },
  props: {
    inputModel: {
      default: '',
    },
    /**
     * Имя \<input\> в DOM
     */
    name: String,
    /**
     * Значение
     */
    value: {
      default: '',
    },
    /**
     * Вертикальное выравнивание
     */
    align: {
      type: String,
      default: 'top',
      validator(value) {
        return ['top', 'center'].indexOf(value) !== -1;
      },
    },
    /**
     * Состояние
     */
    state: {
      type: String,
      validator(value) {
        return ['', 'error', 'warning', 'success'].indexOf(value) !== -1;
      },
    },
    /**
     * Делает чекбокс неопределенным
     */
    indeterminate: Boolean,
    /**
     * Блокирует чекбокс
     */
    disabled: Boolean,
  },
  computed: {
    internalValue: {
      get() {
        return this.inputModel;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    classes() {
      return {
        'rr-checkbox_align_top': this.align === 'top',
        'rr-checkbox_align_center': this.align === 'center',
        'has-error': this.state === 'error',
        'has-warning': this.state === 'warning',
        'has-success': this.state === 'success',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./Checkbox";
</style>
